module.exports = __webpack_public_path__ + "static/media/account_profile.ad1f83a7.png";